import { base_colorContentBorder } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  height: 100vh;
  width: 100%;
  position: relative;
  padding: 0 ${spacing(10)};

  .BrandPartnership-logo {
    max-height: 40px;
    height: 40px;
    object-fit: contain;

    &:not(:last-child) {
      padding-right: ${spacing(5)};
      border-right: 2px solid ${base_colorContentBorder};
    }
  }

  .logo-container {
    display: flex;
    align-items: center;
    height: 120px;
  }

  .asterisk-text {
    padding-top: ${spacing(6)};
  }

  .footer {
    margin-top: ${spacing(12)};
    padding-bottom: ${spacing(15)};
  }
`
